export const setPackages = packages => ({
    type: 'SET_PACKAGES',
    payload: packages
});

export default setPackages;